export const constants = {
  API_URL: 'https://client-api.fluxuro.ai/api',
  // API_URL: 'http://localhost:4001/api',
  API_SOCKET_URL: 'https://client-api.fluxuro.ai',
  // API_SOCKET_URL: 'http://localhost:4001',
  MIND_URL: 'https://mind.fluxuro.ai',
  // MIND_URL: 'http://localhost:4200',
};

export default constants;
